// extracted by mini-css-extract-plugin
module.exports = {"footer_modal":"Modal_footer_modal__2wYjD","btn_cancel":"Modal_btn_cancel__2I3Eg","btn_submit":"Modal_btn_submit__3XIzx"};